<template>
  <section class="site-top-menu">
    <div>
      <b-nav tabs ref="topMenu">
        <b-nav-item :to="{name: 'sites'}" :active="activeTab==='sites'"
        >Сайты
        </b-nav-item>

        <b-nav-item :to="{name: 'siteGroup'}" :active="activeTab==='groups'">
          Группы сайтов
        </b-nav-item>
      </b-nav>
    </div>

    <!--    second menu-->
    <div class="mt-4">
      <b-nav tabs ref="secondMenu">
        <template v-if="activeTab==='sites'">
          <b-nav-item
              :to="{name:  'sites'}"
              :active="this.$router.currentRoute.name ==  'sites'"
          >Список
          </b-nav-item>

          <b-nav-item
              :to="{name: 'siteSearchEngine'}"
              :active="this.$router.currentRoute.name == 'siteSearchEngine'">
            Настройки ПС
          </b-nav-item>

          <b-nav-item
              :to="{name: 'siteStatistic'}"
              :active="this.$router.currentRoute.name == 'siteStatistic' || this.$router.currentRoute.name == 'siteChartStatistic'"
          >Статистика
          </b-nav-item>

          <b-nav-item
              :to="{name:  'sitePositions', params: { id: siteId } }"
              :active="this.$router.currentRoute.name == 'sitePositions'"
          >Позиции
          </b-nav-item>

          <b-nav-item
              :to="{name:  'siteSettings', params: { id: siteId } }"
              :active="this.$router.currentRoute.name ==  'siteSettings'"
          >Настройки
          </b-nav-item>

          <b-nav-item
              :to="{name: 'indexing', params: {id: siteId}}"
              :active="this.$router.currentRoute.name == 'indexing'"
          >Индексация
          </b-nav-item>
        </template>
        <template v-else>
          <b-nav-item
              :to="{name:  'siteGroup'}"
              :active="this.$router.currentRoute.name == 'siteGroup'"
          >Список
          </b-nav-item>

          <b-nav-item
              :to="{name:  'groupPosition', params: { groupId: siteId } }"
              :active="this.$router.currentRoute.name == 'groupPosition'"
          >Позиции
          </b-nav-item>
        </template>
      </b-nav>
    </div>
  </section>
</template>

<script>
export default {
  name: "topMenu",
  props: {
    siteId: String,
    groupId: String,
    domain: String,
  },
  computed: {
    activeTab() {
      return ['sites', 'siteSettings', 'indexing', 'sitePositions', 'siteStatistic', 'siteSearchEngine'].includes(this.$router.currentRoute.name) ? 'sites' : 'groups';
    }
  }
}
</script>

<style scoped>
.translation-top-menu {
  margin-bottom: 20px;
}
</style>